import { getCentrifuge } from "@/src/lib/centrifuge";
import { requestCentrifugoToken } from "@/src/lib/requestCentrifugoToken";

let lastAccessToken: string | null = null;

export async function connectCentrifugo(accessToken: string): Promise<void> {
  const centrifuge = getCentrifuge();
  if (!centrifuge) return;

  if (lastAccessToken === accessToken && centrifuge.isConnected()) {
    return;
  }

  const wsToken = await requestCentrifugoToken(accessToken);

  centrifuge.setToken(wsToken);
  centrifuge.setSubscribeHeaders({
    Authorization: `Bearer ${accessToken}`,
  });
  centrifuge.connect();

  lastAccessToken = accessToken;
}

export async function forceReconnectCentrifugo(accessToken: string): Promise<void> {
  disconnectCentrifugo();
  await connectCentrifugo(accessToken);
}

export function disconnectCentrifugo(): void {
  const centrifuge = getCentrifuge();
  if (!centrifuge) return;

  try {
    centrifuge.disconnect();
  } finally {
    lastAccessToken = null;
  }
}
